const getters = {
  getProvinces: (state) => state.provinces,
};

export default getters;
